import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/40">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold text-foreground-50 font-heading whitespace-nowrap">
                大师兄影视
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              大师兄影视提供海量免费电影、电视剧在线观看，高清画质不卡顿，全集播放，畅享流畅观影体验。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
              影视分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-foreground-600"></i>
                <span>contact@dashixiong.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-customer-service-2-line text-foreground-600"></i>
                <span>在线客服 7x24小时</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-foreground-600"></i>
                <span>北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-background-200/40 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 大师兄影视 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-foreground-400 transition-colors text-xs" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-400 transition-colors text-xs" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-400 transition-colors text-xs" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}